export enum SessionStorageKey {
  KeycloakTokens = 'KeycloakTokens',
  RegisterData = 'RegisterData',
  WecareMobile = 'WecareMobile',
  WecareCountryCode = 'WecareCountryCode',
  i18nLanguage = 'i18nLanguage',
  over4 = 'over4',
  uploadData = 'uploadData',
  genbravoSessionFlag = 'genbravoSessionFlag',
  promPop = 'promPop',
  ebPromPop = 'ebPromPop',
}

type Key = SessionStorageKey | `${SessionStorageKey}`;

class SessionStorageService {
  set(key: Key, item: string) {
    sessionStorage.setItem(key, item);
  }

  get(key: Key) {
    return sessionStorage.getItem(key);
  }

  remove(key: Key) {
    sessionStorage.removeItem(key);
  }

  clear() {
    sessionStorage.clear();
  }

  getKeyByIndex(index: number) {
    return sessionStorage.key(index);
  }
}

export const sessionStorageService = new SessionStorageService();
